export default __webpack_public_path__ + "static/media/footer-logo.2d3628e5.png";